var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1075_2759)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.68 8.85121C15.68 8.28393 15.6291 7.73848 15.5345 7.21484H8V10.3094H12.3055C12.12 11.3094 11.5564 12.1567 10.7091 12.7239V14.7312H13.2945C14.8073 13.3385 15.68 11.2876 15.68 8.85121Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 16.6685C10.1607 16.6685 11.9716 15.9521 13.2952 14.7303L10.7097 12.723C9.99338 13.203 9.07702 13.4867 8.00065 13.4867C5.91702 13.4867 4.15338 12.0794 3.52429 10.1885H0.851562V12.2612C2.16793 14.8758 4.87338 16.6685 8.00065 16.6685Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52364 10.1889C3.36364 9.7089 3.27273 9.19617 3.27273 8.6689C3.27273 8.14163 3.36364 7.6289 3.52364 7.1489V5.07617H0.850909C0.309091 6.15617 0 7.37799 0 8.6689C0 9.95981 0.309091 11.1816 0.850909 12.2616L3.52364 10.1889Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 3.85076C9.1752 3.85076 10.2297 4.2544 11.0588 5.04713L13.3534 2.75258C11.9679 1.46167 10.157 0.668945 8.00065 0.668945C4.87338 0.668945 2.16793 2.46167 0.851562 5.07622L3.52429 7.14895C4.15338 5.25804 5.91702 3.85076 8.00065 3.85076Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1075_2759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.668945)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/Google Icon.c5e1a67e3f78d5246bf749323de7c8fd.svg";
export { ForwardRef as ReactComponent };